import { baseUrlForRTM, getOptions } from "../utilities/metricsConfig";
import axios from "axios";

class RTMMetricsService {
  constructor(baseUrl) {
    this.basePath = "/";
    this.baseUrl = `${baseUrl}${this.basePath}`;
  }

  getLineMetrics(line, parameters) {
    return axios(
      getOptions(this.baseUrl, `model/description/line/${line}`, parameters)
    );
  }

  getStationMetrics(station, parameters) {
    return axios(
      getOptions(
        this.baseUrl,
        `model/description/station/${station}`,
        parameters
      )
    );
  }
}

const rtmMetricsService = new RTMMetricsService(baseUrlForRTM);

export default rtmMetricsService;
